



<template>
  
<v-layout row wrap>
  <v-flex xs12>
    <v-card
    v-bind:class="{ 'noBoxShadow' : getScreenWidth() > 900, 'pa-3 map' : true} "
      elevation-1
    >
       <v-toolbar
      color="white"
      style="width:100%"
      floating
      dense
      class=" mr-0 ml-0 mb-3" elevation-1
    >
      
          <v-icon>location_on</v-icon>
            {{ifw}}
    </v-toolbar>
  


    <Gmap-Map style="width: 100%; height: 300px;" :zoom="12" :center="center"  ref="map">
      <Gmap-Marker
        :position="marker.position"
        :clickable="true" 
        :draggable="false"
        @click="opened = !opened"
        >
           <gmap-info-window :opened="opened" >{{ifw}}</gmap-info-window>
        
        </Gmap-Marker>
    </Gmap-Map>
    </v-card>
</v-flex>
  </v-layout>
 

</template>

<script>
export default {
  data() {
    return {
      place: {
        formatted_address: "Add a location or drag marker."
      },
      opened: true
    };
  },
  props: ["location"],
  update() {
    this.$refs.map.resize();
  },
  methods : {
    getScreenWidth(){ 
          return screen.width;
      }
  },
  computed: {
    center() {
      return {
         lng: this.location.geometry.location.lng,
         lat: this.location.geometry.location.lat
      }
    },
    marker() {
      if (typeof this.location.geometry.location.lat == 'function')
      return {
        position: {
          lng: this.location.geometry.location.lng(),
          lat: this.location.geometry.location.lat()
        }
      }
      else
        return {
        position: {
          lng: this.location.geometry.location.lng,
          lat: this.location.geometry.location.lat
        }
      }
    },
    ifw() {
      return this.location.formatted_address;
    }
  },
  created() {
    if (typeof this.location.geometry.location.lng == 'string')
    {
      this.location.geometry.location.lng = parseFloat(this.location.geometry.location.lng);
      this.location.geometry.location.lat= parseFloat(this.location.geometry.location.lat); 
    }
    else if (typeof this.location.geometry.location.lng == 'function') {
        this.location.geometry.location.lng = this.location.geometry.location.lng()
      this.location.geometry.location.lat= this.location.geometry.location.lat();
    }
  }
};
</script>


<style>
.toolbar__content {
  width: -webkit-fill-available !important;
}

.noBoxShadow { 
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/PresentLocation.vue